// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");

function makeOptionItems(options, selectedOptions) {
  return List.map((function (x) {
                return {
                        name: x,
                        selected: List.exists((function (y) {
                                return y === x;
                              }), selectedOptions)
                      };
              }), options);
}

function SelectBox(props) {
  var __className = props.className;
  var __selectedOptions = props.selectedOptions;
  var handleChange = props.handleChange;
  var placeholder = props.placeholder;
  var selectedOptions = __selectedOptions !== undefined ? __selectedOptions : /* [] */0;
  var className = __className !== undefined ? __className : "";
  var optionItems = makeOptionItems(props.options, selectedOptions);
  var match = React.useState(function (param) {
        return {
                open_: false
              };
      });
  var setState = match[1];
  var domElement = React.useRef(null);
  var handleOutsideClick = function ($$event) {
    var targetElement = $$event.target;
    var selectBoxElement = Belt_Option.getExn(Caml_option.nullable_to_opt(domElement.current));
    if (!selectBoxElement.contains(targetElement)) {
      return Curry._1(setState, (function (param) {
                    return {
                            open_: false
                          };
                  }));
    }
    
  };
  React.useEffect((function (param) {
          document.addEventListener("mousedown", handleOutsideClick);
          return (function (param) {
                    document.removeEventListener("mousedown", handleOutsideClick);
                  });
        }), []);
  var handleClick = function ($$event) {
    $$event.preventDefault();
    $$event.stopPropagation();
    Curry._1(setState, (function (state) {
            return {
                    open_: !state.open_
                  };
          }));
  };
  var removeOption = function (optionName) {
    return Belt_List.keep(selectedOptions, (function (x) {
                  return x !== optionName;
                }));
  };
  var addOption = function (optionName) {
    return Belt_List.concat({
                hd: optionName,
                tl: /* [] */0
              }, selectedOptions);
  };
  var listBoxCSS = match[0].open_ ? "block" : "hidden";
  var tmp;
  var exit = 0;
  if (placeholder !== undefined) {
    if (selectedOptions) {
      exit = 1;
    } else {
      tmp = placeholder;
    }
  } else if (selectedOptions) {
    exit = 1;
  } else {
    tmp = "";
  }
  if (exit === 1) {
    tmp = List.fold_left((function (x, y) {
            return x + ("," + y);
          }), selectedOptions.hd, selectedOptions.tl);
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("p", {
                            children: tmp,
                            className: "border truncate px-2",
                            onClick: handleClick
                          }),
                      className: "w-full"
                    }),
                JsxRuntime.jsx("div", {
                      children: $$Array.of_list(Belt_List.mapWithIndex(optionItems, (function (i, x) {
                                  return JsxRuntime.jsx("button", {
                                              children: x.name,
                                              className: x.selected ? "bg-blue-200 px-5" : "hover:bg-gray-300 px-5",
                                              value: x.name,
                                              onClick: (function ($$event) {
                                                  $$event.preventDefault();
                                                  Curry._1(handleChange, (
                                                          x.selected ? removeOption : addOption
                                                        )(x.name));
                                                })
                                            }, String(i));
                                }))),
                      className: "flex flex-col border my-2 z-50 bg-white " + listBoxCSS,
                      style: {
                        height: "20%",
                        overflow: "scroll",
                        position: "absolute"
                      }
                    })
              ],
              ref: Caml_option.some(domElement),
              className: className
            }, "key");
}

var make = SelectBox;

exports.makeOptionItems = makeOptionItems;
exports.make = make;
/* react Not a pure module */
